import React from 'react';
import { useTranslation } from 'react-i18next';
import { Copy } from 'lucide-react';
import PartnershipDetailLayout from './PartnershipDetailLayout';

export default function CloneSitePage() {
  const { t } = useTranslation();
  return (
    <PartnershipDetailLayout
      testId="clone-site-page"
      icon={Copy}
      badgeLabel={t('partnership.clone.badge')}
      title={t('partnership.clone.title')}
      titleAccent={t('partnership.clone.titleAccent')}
      intro={t('partnership.clone.intro')}
      ctaType="clone"
      sections={[
        {
          title: t('partnership.clone.s1Title'),
          items: [
            t('partnership.clone.s1I1'),
            t('partnership.clone.s1I2'),
            t('partnership.clone.s1I3'),
            t('partnership.clone.s1I4'),
            t('partnership.clone.s1I5'),
            t('partnership.clone.s1I6'),
            t('partnership.clone.s1I7'),
          ],
        },
        {
          title: t('partnership.clone.s2Title'),
          paragraphs: [
            t('partnership.clone.s2P1'),
            t('partnership.clone.s2P2'),
          ],
        },
        {
          title: t('partnership.clone.s3Title'),
          paragraphs: [
            t('partnership.clone.s3P1'),
            t('partnership.clone.s3P2'),
          ],
        },
      ]}
      faq={[
        { q: t('partnership.clone.faq1Q'), a: t('partnership.clone.faq1A') },
        { q: t('partnership.clone.faq2Q'), a: t('partnership.clone.faq2A') },
        { q: t('partnership.clone.faq3Q'), a: t('partnership.clone.faq3A') },
      ]}
    />
  );
}
